var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMaterialClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_material-close",
    "data-name": "Icon material-close",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1065",
    "data-name": "Ellipse 1065",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-close-2",
    "data-name": "Icon material-close",
    d: "M20.213,8.78,18.933,7.5l-5.076,5.076L8.78,7.5,7.5,8.78l5.076,5.076L7.5,18.933l1.28,1.28,5.076-5.076,5.076,5.076,1.28-1.28-5.076-5.076Z",
    transform: "translate(0.144 0.143)",
    fill: "#7b7b7b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaterialClose);
export default __webpack_public_path__ + "static/media/icon-material-close.29d0aa332c7748f47bee7724a10b67f0.svg";
export { ForwardRef as ReactComponent };